<template>
  <div class="mt-3" v-if="props.item">
    <div class="bg-white/10 flex w-full md:max-w-[370px] flex-col items-stretch pl-3 pr-6 py-5 rounded-2xl">
      <div class="flex items-center justify-between gap-2">
        <div class="flex items-center gap-2">
          <input 
            type="checkbox" 
            :id="'radio-' + props.keyName"
            v-model="isChecked"
            @change="toggleCheckbox"
            class="w-4 h-4 text-primary-1000 bg-transparent border-op-white-100 rounded focus:ring-none focus:ring-0"
          />
          <label :for="'radio-' + props.keyName" class="text-op-white-800 text-sm cursor-pointer">
            {{ props.item.name }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const isChecked = ref(false);

const props = defineProps({
  item: {
    type: Object,
  },
  keyName: {
    type: String,
    default: "button",
  },
});

onMounted(() => {
  isChecked.value = props.item.selected == props.item.data ? true : false;
});

const emit = defineEmits(["updated"]);

const toggleCheckbox = () => {
  emit("updated", { name: props.keyName, data: isChecked.value ? [props.item.data] : [] });
};
</script> 